import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FoundationServiceService } from '../../../features/services/foundation-service.service';
import { SharedDataService } from '../../shared-data.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-notes-dialog',
  templateUrl: './notes-dialog.component.html',
  styleUrls: ['./notes-dialog.component.scss'],
})
export class NotesDialogComponent implements OnInit , OnDestroy{
  note: string = '';
  notes: any[] = [];
  displayedColumns: string[] = ['noteText'];
  screenSection: any;
  status:string='';
  private readonly destroy$: Subject<void> = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<NotesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: FoundationServiceService,
    private sharedData: SharedDataService
  ) {
    if (data?.notes) {
      this.notes = [...data.notes];
    }
    if (data?.screenSection) {
      this.screenSection = data.screenSection;
    }
  }

  ngOnInit(): void {
    this.sharedData.requestStatusChanged$.pipe(takeUntil(this.destroy$)).subscribe(val => {
        this.status = val;
    });
    this.getNotes();
  }
  ngOnDestroy() {
    
    this.destroy$.next();
    this.destroy$.complete();
  }
  getNotes() {
    this.service.getNotes(
      this.sharedData.getRequestId() || 0,
      this.screenSection,
      (this.screenSection == 'ATTACHMENTS' && ['PENDING_CONTRACT_REVIEW','CONTRACT_APPROVED','WAITING_CLIENT_SIGNATURE'].includes(this.status))? '' : 'UNDER_REVIEW').subscribe(
      (res) => {
        this.notes = res.data;
        console.log('Notes loaded:', this.notes);
      },
      (error) => {
        console.error('Error fetching notes:', error);
        // Optionally, show a user-friendly message here
      }
    );
  }
}
